// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3hhed","label":"Radio_label__26wq7","checkMark":"Radio_checkMark__1Z3C2","disabled":"Radio_disabled__2ydZu"};